import SocialLinks from './SocialLinks.js';
const Footer =()=>{
    const date = new Date()
    const year = date.getFullYear()
    // console.log(year);
    return(
        <div>
            <footer className="bg-dark p-1">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className="footer-text mt-3" style={{ color: '#A0A0A0' }}>
                                <i className="bi bi-c-circle"></i> {year}  Norrenberger. All Rights Reserved
                            </p>
                        </div>
                        <div className="col text-end">
                            <SocialLinks/>
                        </div>
                    </div>
                </div>
                
            </footer>
        </div>
    )
}
export default Footer;